import styles from "./EditScreenImageUpload.module.css";
import gallery_icon from "../../assets/images/icons/gallery_ace.svg";
import { useState } from "react";

import vertical_upload from "../../assets/images/edit_screen/TypeA20/vertical_upload.png";

import horizontal_upload from "../../assets/images/edit_screen/TypeA20/horizontal_upload.png";

const EditScreenImageUpload = ({ image, callback, remove }) => {
  const [imageOrientation, setImageOrientation] = useState(null);

  function handleImageLoad(event) {
    const { naturalWidth, naturalHeight } = event.target;
    setImageOrientation(
      naturalWidth > naturalHeight ? "horizontal" : "vertical"
    );
  }
  return (
    <div className={styles.main_div}>
      {image === "" && (
        <div
          onClick={(event) => {
            callback();
          }}
          className={styles.placeholder}
        >
          <img
            className={styles.gallery_icon}
            src={gallery_icon}
            alt="top_gallery"
          />
          <div className={styles.placeholder_text}>写真選択</div>
        </div>
      )}
      {image !== "" && (
        <div className={styles.album_single_square_picture_div}>
          {image && (
            <img
              style={{
                maxHeight: imageOrientation === "vertical" ? "450px" : "300px",
                maxWidth: imageOrientation !== "vertical" ? "450px" : "300px",
              }}
              src={image}
              onLoad={handleImageLoad}
              alt={"image_uploaded"}
            />
          )}
          {image && (
            <div
              onClick={() => remove("")}
              className={styles.album_single_square_cross_div}
            >
              <ion-icon
                className={styles.album_single_square_cross_icon}
                name="close"
              ></ion-icon>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default EditScreenImageUpload;
